import React, { useState } from 'react';
import styled from 'styled-components';

import { useService } from '@xstate/react';

import { addFreeSampleToCart } from '../../../context/ProductBuilder/api/addToCart/addFreeSampleToCart';
import { getCartLive } from '../../../context/ProductBuilder/api/getCart/getCartLive';
import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getColourSample } from '../../../helpers/getColourSample';
// import { useDebounce } from '../../../hooks/useDebounce';
// import { useWindowSize } from '../../../hooks/useWindowSize';
import { Cart, TWindow } from '../../../types';
import { AddFreeSampleIcon } from '../../Icon/AddFreeSample';

type Props = {
  title: string;
};

const StyledLimitWrapper = styled.div`
  margin: 1rem auto;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  color: #9f502d;
`;

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto 1rem;
  text-align: center;

  @media (max-width: 1440px) {
    margin: 12px 0 0;
  }

  @media (max-width: 767px) {
    margin: 30px 0 0;
  }
`;

const StyledButton = styled.a<{
  isShown: boolean;
}>`
  display: flex;
  align-items: center;
  font-size: 1rem;
  border: none;
  padding: 10px;
  background-color: transparent;
  border-radius: 5px;
  cursor: pointer;
  width: 280px;
  height: 69px;
  border: 1px solid #dadee2;

  &:hover {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  }

  &[disabled] {
    cursor: not-allowed;
  }
  ${({ isShown }) => {
    if (isShown) {
      return ` cursor: not-allowed; svg{filter: grayscale(100%); opacity: 50%;}`;
    }
  }};
`;

const FreeSampleContentContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const FreeSampleHeader = styled.span`
  font: normal normal normal 13px/14px Lato;
  letter-spacing: 0.26px;
`;

const FreeSampleContent = styled.span`
  font: normal normal normal 10px/14px Lato;
  letter-spacing: 0.2px;
`;

const IconWrapper = styled.div`
  min-width: 55px;
  width: 55px;
  min-height: 49px;
  height: 49px;
  margin-right: 12px;
`;

export const AddFreeSample = (props: Props) => {
  const [state, send] = useService(productBuilderMachine);
  const [isShown, setIsShown] = useState(false);
  const { title } = props;
  const _window = window as TWindow;

  // const windowSize = useWindowSize();
  // const { width: windowWidth } = useDebounce(windowSize, 200);

  if (_window.ajaxCartUpdateData !== undefined && isShown) {
    const updatedCart: Cart = _window.ajaxCartUpdateData;
    const colourSample = getColourSample(state.context, title);
    const updatedColorSampleLimit =
      updatedCart && updatedCart.items && typeof colourSample !== 'undefined'
        ? updatedCart.items.filter(
            item => item.product_type === 'Colour Sample',
          ).length < 12
        : false;
    if (updatedColorSampleLimit) {
      setIsShown(false);
    }
  }

  const addFreeSample = async () => {
    // Get the cart each time first, because the user could remove items from the cart
    // Which lives outside of React, so we have no idea if the items are still there
    const cart = await getCartLive();
    send({
      type: 'UPDATE_CART',
      data: cart,
    });
    // This function is finding the colour sample that relates to the currently selected
    // Colour. EG: You are in Honeycomb Standard Product builder
    // You have chosen Light Filter, then Oxford Blue Colour
    // Find the variant within the colourSamples variants that includes both Light Filter and Oxford Blue
    const colourSample = getColourSample(state.context, title);

    const isInCart =
      cart && cart.items && typeof colourSample !== 'undefined'
        ? cart.items.find(item => item.id === colourSample.id)
        : false;

    const isColorSampleLimit =
      cart && cart.items && typeof colourSample !== 'undefined'
        ? cart.items.filter(item => item.product_type === 'Colour Sample')
            .length >= 12
        : false;

    if (colourSample && !isInCart && !isColorSampleLimit) {
      await addFreeSampleToCart(colourSample.id);
      // We still want to update what is in context anyway in case it needs to be used elsewhere
      const cart = await getCartLive();
      _window.ajaxCartUpdateData = cart;
      send({
        type: 'UPDATE_CART',
        data: cart,
      });
    } else {
      if (isColorSampleLimit) {
        setIsShown(true);
      }
    }
  };

  return (
    <StyledWrapper>
      <StyledButton onClick={addFreeSample} 
      href="/collections/colour-samples"
      // disabled={false} 
      isShown={isShown}>
        <IconWrapper>
          <AddFreeSampleIcon />
        </IconWrapper>
        <FreeSampleContentContainer>
          <FreeSampleHeader>
            Order a <strong>FREE</strong> Colour Sample
          </FreeSampleHeader>
          <FreeSampleContent>
            Not sure what colour will suit your room? Get up to 30 colour
            samples <strong>FREE</strong>
          </FreeSampleContent>
        </FreeSampleContentContainer>
      </StyledButton>
      {isShown && (
        <StyledLimitWrapper>
          YOU HAVE REACHED YOUR 12 FREE COLOUR SAMPLES
        </StyledLimitWrapper>
      )}
    </StyledWrapper>
  );
};
